@let videoId = videoIdField();
@let heading = headingField();

<div class="d-grid gap-2" [class.text-center]="isEd()">
  <h2 class="m-0" *scText="heading"></h2>
  @if (showDescriptionField() && descriptionField(); as descriptionField) {
    <p class="m-0" *scText="descriptionField"></p>
  }

  @if (videoId && videoId.value && heading && heading.value) {
    <wl-video-player [videoId]="videoId.value" [title]="heading.value" />
  }

  @if (isEditorActive()) {
    <div class="text-center border rounded p-2 bg-light">
      <span class="form-label fw-bold d-block">YouTube video ID</span>
      <span class="d-block text-muted" *scText="videoIdField()"
        >Enter the YouTube video ID here</span
      >
    </div>
  }
</div>
